import { Length, Matches } from 'class-validator';

import {
  ERROR_MESSAGE,
  HAS_EMOJI,
  HAS_INVALID_NICKNAME,
  HAS_VALID_SLUG_FORMAT,
  NICKNAME_MAX_LENGTH,
  NICKNAME_MIN_LENGTH,
  SLUG_MAX_LENGTH,
  SLUG_MIN_LENGTH,
} from './constants';
import { NotMatches, Trim } from './decorator';

class MyProfileValidator {
  profileImageFileId: number | null;

  @Trim()
  @NotMatches(RegExp(HAS_EMOJI), {
    message: ERROR_MESSAGE.INVALID_EMOJI,
  })
  @Matches(RegExp(HAS_INVALID_NICKNAME), {
    message: ERROR_MESSAGE.INVALID_NICKNAME,
  })
  @Length(NICKNAME_MIN_LENGTH, NICKNAME_MAX_LENGTH, {
    message: ERROR_MESSAGE.COMMON_LENGTH(NICKNAME_MIN_LENGTH, NICKNAME_MAX_LENGTH),
  })
  nickname: string;

  @Trim()
  @Matches(RegExp(HAS_VALID_SLUG_FORMAT), {
    message: ERROR_MESSAGE.INVALID_SLUG_FORMAT,
  })
  @Length(SLUG_MIN_LENGTH, SLUG_MAX_LENGTH, {
    message: ERROR_MESSAGE.COMMON_LENGTH(SLUG_MIN_LENGTH, SLUG_MAX_LENGTH),
  })
  slug: string;

  @Trim()
  introduce: string;
}

export default MyProfileValidator;
